// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export * from "./bytesEncoding.common.js";
//# sourceMappingURL=bytesEncoding-browser.mjs.map